module.exports = __webpack_public_path__ + "static/media/building.88768c49.svg";